import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { SingleProject } from '../../views/twig/pages/single-project';
import { ArchiveProjects } from '../twig/pages/archive-project';
import { PageTeam } from '../twig/pages/page-team';
/*(new Analytics()).init();
(new Carousel()).init();
(new Collapse()).init();
(new Demo()).init();
(new Dropdown()).init();*/
(new LazyLoader()).init();
/*(new ScrollSpy()).init();
(new DarkMode()).init();*/
(new Menu()).init();
(new SingleProject()).init();
(new ArchiveProjects()).init();
(new PageTeam()).init();
// Always at the end
/*(new CookiesConsent()).init();*/
